const ENDPOINT_URL = '/api/search?q=';
const LOCALE = 'cs';

export default () => ({
  blogPosts: {
    data: [],
  },
  query: '',
  searching: false,

  get hasPosts() {
    return this.blogPosts.data.length > 0;
  },

  get hasQuery() {
    return this.query.length > 0;
  },

  get noResults() {
    return !this.searching && this.hasQuery && !this.hasPosts;
  },

  formatDate(date) {
    let fomatedDate = new Date(date);
    return fomatedDate.toLocaleDateString(LOCALE);
  },

  search(query) {
    this.query = query;
    this.searching = true;
    fetch(`${ENDPOINT_URL}${query}`)
      .then((response) => response.json())
      .then((data) => {
        this.blogPosts = data;
      })
      .finally(() => {
        this.searching = false;
      });
  },
});
